import type {
  ClientCompany,
  UserResponse,
} from 'walden-fast/types/fast-backend/user';
import type { Factory } from 'walden-fast/types/mocks';

const MOCK_CLIENT_RESPONSE: ClientCompany = { id: '2', displayName: 'DEMO' };

const MOCK_USER_RESPONSE: UserResponse = {
  account: {
    id: '2',
    displayName: 'Walden Group',
    externalIdentifiers: {
      powerBI: {
        clientNameMaster: '',
      },
    },
  },
  userProfile: {
    id: '1',
    displayName: 'John Doe',
    givenName: 'John',
    surname: 'Doe',
    mail: 'johndoe@walden-group.com',
    preferredLanguage: 'en-US',
  },
  userAccount: {
    role: 'WaldenAdministrator',
    features: [],
    permissions: [
      {
        $type: 'Impersonation',
        properties: {
          allowedAccountsToImpersonate: [
            {
              id: '1',
              displayName: 'Pizza Planet',
            },
          ],
          allowedClientCompaniesToImpersonate: [
            {
              id: '11',
              displayName: 'Pizza Planet BE',
            },
            {
              id: '12',
              displayName: 'Pizza Planet NL',
            },
          ],
        },
        granted: true,
      },
    ],
    services: [
      {
        active: true,
        serviceUniqueName: 'Walden-View',
        subServiceUniqueName: 'Warehousing',
        subscriptionPeriods: [
          {
            activeFromLocalTime: '1/05/2025',
            activeToLocalTime: '1/05/2099',
            name: 'nl-BE',
            format: 'd/MM/yyyy',
          },
        ],
      },
      {
        active: true,
        serviceUniqueName: 'Walden-View',
        subServiceUniqueName: 'Transport',
        subscriptionPeriods: [
          {
            activeFromLocalTime: '1/05/2025',
            activeToLocalTime: '1/05/2099',
            name: 'nl-BE',
            format: 'd/MM/yyyy',
          },
        ],
      },
      {
        active: true,
        serviceUniqueName: 'Walden-View',
        subServiceUniqueName: 'Order-Tracking',
        subscriptionPeriods: [
          {
            activeFromLocalTime: '1/05/2025',
            activeToLocalTime: '1/05/2099',
            name: 'nl-BE',
            format: 'd/MM/yyyy',
          },
        ],
      },
      {
        active: true,
        serviceUniqueName: 'Walden-View',
        subServiceUniqueName: 'Order-2-Cash',
        subscriptionPeriods: [
          {
            activeFromLocalTime: '1/05/2025',
            activeToLocalTime: '1/05/2099',
            name: 'nl-BE',
            format: 'd/MM/yyyy',
          },
        ],
      },
      {
        active: true,
        serviceUniqueName: 'Walden-Green',
        subServiceUniqueName: 'Level-0',
        subscriptionPeriods: [
          {
            activeFromLocalTime: '1/05/2025',
            activeToLocalTime: '1/05/2099',
            name: 'nl-BE',
            format: 'd/MM/yyyy',
          },
        ],
      },
      {
        active: true,
        serviceUniqueName: 'Walden-Green',
        subServiceUniqueName: 'Level-1',
        subscriptionPeriods: [
          {
            activeFromLocalTime: '1/05/2025',
            activeToLocalTime: '1/05/2099',
            name: 'nl-BE',
            format: 'd/MM/yyyy',
          },
        ],
      },
      {
        active: true,
        serviceUniqueName: 'Walden-Green',
        subServiceUniqueName: 'Level-2',
        subscriptionPeriods: [
          {
            activeFromLocalTime: '1/05/2025',
            activeToLocalTime: '1/05/2099',
            name: 'nl-BE',
            format: 'd/MM/yyyy',
          },
        ],
      },
      {
        active: true,
        serviceUniqueName: 'Walden-Green',
        subServiceUniqueName: 'Level-3',
        subscriptionPeriods: [
          {
            activeFromLocalTime: '1/05/2025',
            activeToLocalTime: '1/05/2099',
            name: 'nl-BE',
            format: 'd/MM/yyyy',
          },
        ],
      },
      {
        active: true,
        serviceUniqueName: 'Walden-ML',
        subServiceUniqueName: 'All',
        subscriptionPeriods: [
          {
            activeFromLocalTime: '1/05/2025',
            activeToLocalTime: '1/05/2099',
            name: 'nl-BE',
            format: 'd/MM/yyyy',
          },
        ],
      },
      {
        active: true,
        serviceUniqueName: 'Walden-Orchestration',
        subServiceUniqueName: 'All',
        subscriptionPeriods: [
          {
            activeFromLocalTime: '1/05/2025',
            activeToLocalTime: '1/05/2099',
            name: 'nl-BE',
            format: 'd/MM/yyyy',
          },
        ],
      },
      {
        active: true,
        serviceUniqueName: 'Walden-Connect',
        subServiceUniqueName: 'All',
        subscriptionPeriods: [
          {
            activeFromLocalTime: '1/05/2025',
            activeToLocalTime: '1/05/2099',
            name: 'nl-BE',
            format: 'd/MM/yyyy',
          },
        ],
      },
      {
        active: true,
        serviceUniqueName: 'Walden-Trace',
        subServiceUniqueName: 'All',
        subscriptionPeriods: [
          {
            activeFromLocalTime: '1/05/2025',
            activeToLocalTime: '1/05/2099',
            name: 'nl-BE',
            format: 'd/MM/yyyy',
          },
        ],
      },
      {
        active: true,
        serviceUniqueName: 'Walden-Box',
        subServiceUniqueName: 'All',
        subscriptionPeriods: [
          {
            activeFromLocalTime: '1/05/2025',
            activeToLocalTime: '1/05/2099',
            name: 'nl-BE',
            format: 'd/MM/yyyy',
          },
        ],
      },
      {
        active: true,
        serviceUniqueName: 'Walden-Pulse',
        subServiceUniqueName: 'All',
        subscriptionPeriods: [
          {
            activeFromLocalTime: '1/05/2025',
            activeToLocalTime: '1/05/2099',
            name: 'nl-BE',
            format: 'd/MM/yyyy',
          },
        ],
      },
      {
        active: true,
        serviceUniqueName: 'Walden-VAS',
        subServiceUniqueName: 'All',
        subscriptionPeriods: [
          {
            activeFromLocalTime: '1/05/2025',
            activeToLocalTime: '1/05/2099',
            name: 'nl-BE',
            format: 'd/MM/yyyy',
          },
        ],
      },
    ],
  },
  clientCompanies: [
    {
      id: '11',
      displayName: 'Pizza Planet BE',
      externalIdentifiers: {
        powerBI: {
          clientNameMaster: 'Pizza Planet',
          clientNameLocal: 'Pizza Planet BE',
        },
      },
    },
    {
      id: '12',
      displayName: 'Pizza Planet NL',
      externalIdentifiers: {
        powerBI: {
          clientNameMaster: 'Pizza Planet',
          clientNameLocal: 'Pizza Planet NL',
        },
      },
    },
  ],
};

export const userResponseFactory: Factory<UserResponse> = (overrides) => ({
  ...MOCK_USER_RESPONSE,
  ...overrides,
});

export const clientResponseFactory: Factory<ClientCompany> = (overrides) => ({
  ...MOCK_CLIENT_RESPONSE,
  ...overrides,
});
